import React from 'react';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const Button = ({ children, variant = 'primary', className, ...props }) => {
  const baseStyles = "relative inline-flex items-center justify-center gap-2 px-6 py-3 font-medium rounded-xl transition-all duration-200 active:scale-95 disabled:opacity-50 disabled:pointer-events-none";
  
  const variants = {
    primary: "bg-[#0094f7] hover:bg-[#007acc] text-white shadow-[0_0_20px_rgba(0,148,247,0.3)] hover:shadow-[0_0_25px_rgba(0,148,247,0.5)]",
    secondary: "bg-slate-800 text-slate-100 hover:bg-slate-700 border border-slate-700",
    outline: "border-2 border-[#d2ff02] text-[#d2ff02] hover:bg-[#d2ff02]/10",
    ghost: "text-slate-300 hover:text-white hover:bg-white/5"
  };

  return (
    <button className={cn(baseStyles, variants[variant], className)} {...props}>
      {children}
    </button>
  );
};